import { useRefetchQuery } from "libs/reactQuery";
import { SocketsContext } from "libs/soket";
import { useContext, useEffect, useState } from "react";

import { DamagedItemsCountEventData } from "../siteBarCounters.types";

export const useDamagedItemsCounter = () => {
  const { damagedItemsSocket } = useContext(SocketsContext);

  const [damagedItemsCount, setDamagedItemsCount] = useState<number>(0);

  const refetchDamagedItems = useRefetchQuery([
    "inventory-manager-admin",
    "all-damaged-items"
  ]);

  useEffect(() => {
    if (damagedItemsSocket.socket) {
      damagedItemsSocket.socket?.on(
        "damaged-items-count",
        (data: DamagedItemsCountEventData) => {
          if (data.countOfUnreadItems) {
            setDamagedItemsCount(data.countOfUnreadItems);
          }

          if (data.countIncremented) {
            setDamagedItemsCount((prev) => prev + (data.countIncremented ?? 0));
            refetchDamagedItems();
          }
        }
      );
    }

    return () => {
      damagedItemsSocket?.socket?.off("damaged-items-count");
    };
  }, [damagedItemsSocket.socket]);

  return { damagedItemsCount };
};
